<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-else>
      <b-row>
        <b-col md="5">
          <h3>Customer Management</h3>
        </b-col>
      </b-row>
      <b-card>
        <b-row>
          <b-col><b-row><b-col>
                <h3>
                  {{ details && details.name ? details.name.first : "" }}
                </h3>
                <h5 class="mt-4">
                  <img :src="`img/logo.png`" class="mr-2 icon-height" />
                  <h5 style="margin-top: -15px; margin-left: 28px">
                    {{ details ? details.customerNo : "" }}
                  </h5>
                </h5>
              </b-col>
            </b-row></b-col>
          <b-col class="mt-2">
            <b-form-checkbox v-model="specialMember" id="checkbox-2" name="checkbox-2" :value="true"
              :unchecked-value="false" :disabled="specialMember === true" @change="getSpecialMember">
              <img class="mx-1" :src="`img/Special _Member_Active.png`" style="height: 25px; width: 25px" />
              Special Member
            </b-form-checkbox>
            <h5 style="margin-top: 28px">
              <img :src="`img/Phone.png`" class="mr-2 mb-1 icon-height" />
              {{ (contactList[0] && contactList[0].phone) || "" }}
            </h5>
          </b-col>
          <b-col class="mt-2">
            <div>
              <img :src="`img/Email.png`" class="icon-height" />
              <h5 style="margin-top: -16px; margin-left: 33px">
                {{ (contactList[1] && contactList[1].email) || "" }}
              </h5>
            </div>
            <template class="mt-4 row" v-for="(address, index) in details.addresses">
              <div :key="index" v-if="address.isDefault == true" style="margin-top: 28px">
                <img :src="`img/Location.png`" class="ml-1 mr-2 icon-height" />
                <h5 style="display: inline; position: absolute; margin-top: 0px">
                  {{ address.street1 }},{{ address.street2 }},
                  {{ address.city }},
                  {{ address.state }}
                  {{ address.country }}, {{ address.zip }}
                </h5>
              </div>
              <div :key="index" v-if="details.addresses.length == 1 && address.isDefault == false
                " style="margin-top: 28px">
                <img :src="`img/Location.png`" class="ml-1 mr-2 icon-height" />
                <h5 style="display: inline; position: absolute; margin-top: 0px">
                  {{ address.street1 }},{{ address.street2 }},
                  {{ address.city }},
                  {{ address.state }}
                  {{ address.country }}, {{ address.zip }}
                </h5>
              </div>
            </template>
          </b-col>
          <b-col class="ml-auto">
            <b-button v-if="this.$currentUserData.category === 'DISTRIBUTOR' ||
              this.$currentUserData.category === 'DEALER' ||
              this.$currentUserData.category === 'SUB_DEALER'
              " variant="primary" @click="
    $router.push({
      name: 'raise-service-request',
      params: {
        customerData: details,
        id: details._id,
        customerId: currentUser.id,
      },
    })
    " style="width: 158px">
              <i class="fa fa-plus" aria-hidden="true"></i> New Service
              Request</b-button>
            <b-button class="mt-2 ml-5" variant="success" v-b-modal.modal-show-data>Show Referrer
            </b-button>
            <b-modal id="modal-show-data" centered ok-only>
              <h5 class="my-4">
                Referred Customer Name :
                {{
                  referralDetails && referralDetails.name
                  ? referralDetails.name.first
                  : ""
                }}
                {{
                  referralDetails && referralDetails.name
                  ? referralDetails.name.last
                  : ""
                }}
              </h5>
              <h5>
                Referral TID :
                {{ referralDetails ? referralDetails.customerNo : "" }}
              </h5>
            </b-modal>

            <div class="tap-top2">
              <i class="fa fa-phone" aria-hidden="true"></i>
            </div>
          </b-col>
        </b-row>
      </b-card>
      <b-tabs v-model="tabIndex" pills lazy>
        <b-tab>
          <template #title>
            <strong>Order</strong>
            <b-button class="mx-2 customerDetails" variant="dark" pill>{{
              orderCount || 0
            }}</b-button>
          </template>
          <order></order>
        </b-tab>
        <b-tab>
          <template #title>
            <strong>Awards & Benefits </strong>
            <b-button class="mx-2 customerDetails" variant="dark" pill>{{
              awardCount || 0
            }}</b-button>
          </template>
          <awardBenefits />
        </b-tab>
        <b-tab>
          <template #title>
            <strong>Address Management </strong>
            <b-button class="mx-2 customerDetails" variant="dark" pill>{{
              addressCount || 0
            }}</b-button>
          </template>
          <addressManagement />
        </b-tab>
        <b-tab>
          <template #title>
            <strong>Service Request </strong>
            <b-button class="mx-2 customerDetails" variant="dark" pill>{{
              serviceRequestCount || 0
            }}</b-button>
          </template>
          <serviceRequest />
        </b-tab>
        <b-tab>
          <template #title>
            <strong>My Referrals</strong>
            <b-button class="mx-2 customerDetails" variant="dark" pill>
              {{ direct + group || 0 }}
            </b-button>
          </template>
          <b-card class="referrals-header"><template #header>
              <div>
                <h4 class="text-white">Referrals Count</h4>
              </div>
            </template>
            <v-card-text class="my-2">
              <div class="row">
                <h4 class="col-10">Direct Referrals</h4>
                <h4 class="col-2">{{ direct }}</h4>
              </div>
              <div class="row">
                <h4 class="col-10">Group Referrals</h4>
                <h4 class="col-2">{{ group }}</h4>
              </div>
            </v-card-text></b-card>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import VueSimpleSuggest from "vue-simple-suggest";
import ebSelect from "@/components/FormElements/Select.vue";
import "vue-simple-suggest/dist/styles.css";
import order from "./order.vue";
import addressManagement from "./addressManagement.vue";
import serviceRequest from "./serviceRequest.vue";
import awardBenefits from "./awardBenefits.vue";
import raiseServiceRequestVue from "./raiseServiceRequest.vue";
import { mapGetters } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
export default {
  components: {
    VueSimpleSuggest,
    order,
    addressManagement,
    serviceRequest,
    awardBenefits,
    ebSelect,
    raiseServiceRequestVue,
    loader,
  },
  data() {
    return {
      tabIndex: 0,
      influencer: false,
      specialMember: false,
      currentUser: "",
      details: "",
      search: "",
      referralDetails: "",
      refererId: "",
      direct: 0,
      group: 0,
      loading: false,
      contactList: [],
    };
  },
  computed: {
    ...mapGetters({
      getOrderCount: "customerManagement/GetOrderGraph",
      getAwardCount: "customerManagement/GetAwardGraph",
      getServiceRequestCount: "customerManagement/GetServiceTicketList",
    }),
    orderCount() {
      const dataList = this.getOrderCount;
      if (
        dataList &&
        dataList.response &&
        Array.isArray(dataList.response) &&
        dataList.response.length &&
        dataList.response[0].totalCount
      ) {
        return dataList && dataList.response[0]
          ? dataList.response[0].totalCount
          : 0;
      }
    },
    awardCount() {
      const dataList = this.getAwardCount;
      if (
        dataList &&
        dataList.response &&
        Array.isArray(dataList.response) &&
        dataList.response.length &&
        dataList.response[0].totalAmount
      ) {
        return dataList && dataList.response[0]
          ? dataList.response[0].totalAmount.toFixed(2)
          : 0;
      }
    },
    addressCount() {
      let addressList = this.details?.addresses?.length || "";
      return addressList;
    },
    serviceRequestCount() {
      const dataList = this.getServiceRequestCount;
      if (
        dataList &&
        dataList.data &&
        dataList.data.data &&
        Array.isArray(dataList.data.data) &&
        dataList.data.data.length
      ) {
        return dataList && dataList.data ? dataList.data.data.length : 0;
      }
    },
    getCustomerDetails() {
      return this.$store.getters["customerManagement/GetCustomerDetails"];
    },
  },
  methods: {
    getDeliveryContact() {
      let x = this.details.addresses ? this.details.addresses : "";
      if (x.length == 0) {
        this.contactList.push({
          phone: this.currentUser?.userData?.authentication?.phone || "",
        });
        this.contactList.push({
          email: this.currentUser?.userData?.authentication?.email || "",
        });
      } else {
        let mainAddress = x[0];
        x.forEach((address) => {
          if (address.isDefault == true) {
            mainAddress = address;
          }
        });
        mainAddress.contacts.forEach((contact) => {
          if (contact.contactType == "PRIMARY_PHONE") {
            this.contactList.push({ phone: contact.value });
          }
          if (contact.contactType == "PRIMARY_EMAIL") {
            this.contactList.push({ email: contact.value });
          }
        });
      }
    },
    async fetchCustomerDetails() {
      const payload = {
        id: this.currentUser.id,
      };
      const data = await this.$store.dispatch(
        "customerManagement/customerDetails",
        payload
      );
      this.details = data;
      this.specialMember =
        this.details?.extendedAttributes?.specialMember || false;
      this.getDeliveryContact();
      this.refererId = this.details.metaInfo
        ? this.details.metaInfo.refererId
        : "";
      if (this.refererId) {
        const payload = {
          id: this.refererId,
        };
        const data = await this.$store.dispatch(
          "customerManagement/customerDetails",
          payload
        );
        return (this.referralDetails = data);
      }
      return (this.details = data);
    },
    async fetchReferralDetails() {
      const payload = {
        id: this.currentUser.id,
      };
      const data = await this.$store.dispatch(
        "customerManagement/refDetails",
        payload
      );
      (this.direct = data?.directCount || 0),
        (this.group = data?.groupCount || 0);
    },
    async getSpecialMember() {
      await this.$swal({
        title: "Special Member?",
        text: "Are you sure you want to make this customer a Special Member?",
        type: "success",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          const payload = {
            customer: this.currentUser.id,
            specialMember: this.specialMember,
          };
          this.$store
            .dispatch("customerManagement/specialMember", payload)
            .then((result) => {
              this.$swal({
                title: "Success",
                text: "Special Member Added Successfully",
                type: "success",
              });
            })
            .catch((err) => {
              //
            });
        } else if (result.dismiss === "cancel") {
          this.specialMember = false;
        }
      });
    },
  },
  mounted() {
    this.currentUser = this.$route.params;
    this.fetchCustomerDetails();
    this.fetchReferralDetails();
  },
};
</script>

<style>
.text-grey {
  color: #aaaa;
  background-color: transparent;
}

.btn-dark {
  border-radius: 65%;
  margin-left: 40px;
  height: 28px;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #727cf5;
  background-color: #fff;
  outline-color: black !important;
}

.tap-top2 {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  color: white;
  text-align: center;
  background: green;
  border: none;
  font-size: 25px;
  padding: 2px;
  cursor: pointer;
  float: right;
  margin-top: 14px;
  margin-right: 88px;
}

.icon-height {
  height: 18px;
}

.referrals-header .card-header {
  background: #2c7df7;
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.referrals-header {
  width: 47%;
}

.customerDetails {
  height: auto;
  width: auto;
}

.nav-link.active {
  border: 1px solid #e7c4c4;
  border-bottom: 0px;
  border-radius: 5px 5px 0px 0px;
}
</style>
